interface BannerDismissalData {
  lastDismissedAt: number;
  dismissCount: number;
}

const STORAGE_KEY = 'cib_banner_dismissal';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const MAX_DISMISSALS = 3;

const getBannerDismissalData = (): BannerDismissalData | null => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error reading banner dismissal data:', error);
    return null;
  }
};

const saveBannerDismissalData = (data: BannerDismissalData): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error saving banner dismissal data:', error);
  }
};

export const shouldShowBannerByDismissalRules = (): boolean => {
  const data = getBannerDismissalData();
  
  if (!data) {
    return true;
  }
  
  if (data.dismissCount >= MAX_DISMISSALS) {
    return false;
  }
  
  const now = Date.now();
  const timeSinceLastDismissal = now - data.lastDismissedAt;
  
  if (timeSinceLastDismissal < ONE_DAY_MS) {
    return false;
  }
  
  return true;
};

export const recordBannerDismissal = (): void => {
  const existingData = getBannerDismissalData();
  
  const newData: BannerDismissalData = {
    lastDismissedAt: Date.now(),
    dismissCount: existingData ? existingData.dismissCount + 1 : 1,
  };
  
  saveBannerDismissalData(newData);
};
